export default __webpack_public_path__ + "static/media/RobotoMono-VariableFont.b068a62f.woff2";